// @ts-nocheck
import React from 'react'
import ModelFormField from './ModelFormField'
import ModelDebug from './ModelDebug'
import cx from 'classnames'
import './Form.scss'

const ModelForm = ({ fields = [], className, model, pk, debug = false }) => {
  return (
    <section className={cx('ModelForm', className)}>
      {fields.map(props => (
        <ModelFormField key={props.name} {...{ ...props, model, pk }} />
      ))}
      {debug && <ModelDebug {...{ model, pk }} />}
    </section>
  )
}

export default ModelForm
